<template>
  <div class="collapse collapse-item" :class="{ 'is-active': active }">
    <div 
      :class="[ this.hidden ? '' : 'collapse-header' ]" 
      role="tab" 
      :aria-expanded="active ? 'true' : 'false'" 
      @click="toggle"
    >
      <slot name="collapse-header"></slot>
    </div>
    <TransitionExpand>

      <div class="collapse-content" v-if="active">
        <div class="collapse-content-box">
          <slot name="collapse-body"></slot>
        </div>
      </div>

    </TransitionExpand>
  </div>
</template>

<script>

import TransitionExpand from '@/components/transition/TransitionExpand.vue';

export default {

  name: "Collapse",

  data(){
    return {
      active: false,
    }
  },

  props: {

    selected: {
      type: Boolean,
      required: true,
      default: false
    },
    
    hidden: {
      type: Boolean,
      required: true,
      default: false
    }

  },

  created () {
    this.active = this.selected
  },

  ready () {
    if (this.active) {
      this.$emit('collapse-open', this.index)
    }
  },

  methods: {

    toggle () {
      this.active = !this.active
      if (this.active) {
        this.$emit('collapse-open', this.index)
      }
    }
  },

  components: {
      TransitionExpand,
  }
}
</script>

<style>

.collapse .collapse-header {
  position: relative;
  cursor: pointer;
}

.collapse .collapse-header > div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.collapse .collapse-header h3 {
  font-size: 0.938em;
  font-weight: bold;
}

.collapse .hidden .collapse-header::after {
    display:none;
}

.collapse .collapse-header::after {
  -moz-transition: all .2s;
  -o-transition: all .2s;
  -webkit-transition: all .2s;
  transition: all .2s;
  content: url('arrow-down.svg');
  position: absolute;
  top: calc(50% - 0.8em);
  left: calc(100% - 1.5em);
  color: #c5c9d0;
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  -ms-transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  transform: rotate(0deg);
  cursor: pointer;
}

.collapse.is-active .collapse-header::after {
  -moz-transform: rotate(-180deg);
  -o-transform: rotate(-180deg);
  -ms-transform: rotate(-180deg);
  -webkit-transform: rotate(-180deg);
  transform: rotate(-180deg);
}

.collapse .collapse-content-box {
  -moz-transition: all .9s;
  -o-transition: all .9s;
  -webkit-transition: all .9s;
  transition: all .9s;
}



@media screen and (min-width: 800px) and (max-width: 1200px) {
  .collapse .collapse-header::after {
    display: none;
  }
}

</style>